import { environment } from 'environments/environment';
import Echo from 'laravel-echo';
import PusherConnection from 'pusher-js';
import { BehaviorSubject, Observable } from 'rxjs';

declare global {
    // eslint-disable-next-line no-var
    var Pusher: any;
}

export enum ConnectionStatus {
    CONNECTED = 'connected',
    DISCONNECTED = 'disconnected',
    ERROR = 'error',
    CONNECTING = 'connecting'
}

export class WebSocket {
    protected authEndpointPath: string = '';
    protected authHeaders: { [key: string]: string } = {};
    protected publicChannel: string = 'solido';
    protected privateChannel: string = '';
    private broadcaster: string = environment.WS_BROADCASTER;
    private key: string = environment.WS_KEY;
    protected listenPrivateChannel$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    protected listenPublicChannel$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    protected connectionStatus$: BehaviorSubject<ConnectionStatus> = new BehaviorSubject<ConnectionStatus>(ConnectionStatus.DISCONNECTED);

    protected echo: Echo | null = null;

    public setAuthHeaders(headers: { [key: string]: string }): this {
        this.authHeaders = headers;

        return this;
    }

    protected setPrivateChannel(channel: string): this {
        this.privateChannel = channel;

        return this;
    }

    public getConnectionStatus(): Observable<ConnectionStatus> {
        return this.connectionStatus$.asObservable();
    }

    protected generateEchoInstance(): this {
        this.connectionStatus$.next(ConnectionStatus.CONNECTING);

        globalThis.Pusher = PusherConnection;
        this.echo = new Echo({
            broadcaster: this.broadcaster,
            key: this.key,
            wsHost: environment.WS_HOST,
            wsPort: 443,
            wssPort: 443,
            forceTLS: true,
            enabledTransports: ['ws', 'wss'],
            cluster: '',
            authEndpoint: environment.API_URL + this.authEndpointPath,
            auth: {
                headers: this.authHeaders
            }
        });

        this.echo.connector.pusher.connection.bind('connected', () => {
            console.log('WebSocket connected');
            this.connectionStatus$.next(ConnectionStatus.CONNECTED);
        });

        this.echo.connector.pusher.connection.bind('disconnected', () => {
            console.log('WebSocket disconnected');
            this.connectionStatus$.next(ConnectionStatus.DISCONNECTED);

            setTimeout(() => {
                if (this.connectionStatus$.value !== ConnectionStatus.CONNECTED) {
                    console.log('Intentando reconexión después de desconexión...');
                    this.generateEchoInstance();
                }
            }, 2000);
        });

        this.echo.connector.pusher.connection.bind('error', () => {
            this.connectionStatus$.next(ConnectionStatus.ERROR);

            setTimeout(() => {
                if (this.connectionStatus$.value !== ConnectionStatus.CONNECTED) {
                    console.log('Intentando reconexión después de error...');
                    this.generateEchoInstance();
                }
            }, 2000);
        });

        return this;
    }

    public listenPublicChannel(): Observable<any> {
        this.listenSocketPublicChannel((data) => {
            this.listenPublicChannel$.next(data);
        });

        return this.listenPublicChannel$.asObservable();
    }

    protected listenSocketPublicChannel(onEvent: (data: any) => void): void {
        this.generateEchoInstance();

        if (!this.echo) {
            return;
        }

        this.echo.channel(this.publicChannel)['listenToAll']((_eventName: any, _eventData: any) => {
            onEvent(_eventData);
        });
    }

    protected listenSocketPrivateChannel(onEvent: (data: any) => void): void {
        this.generateEchoInstance();

        if (!this.echo) {
            return;
        }

        this.echo.private(this.privateChannel)['listenToAll']((_eventName: any, _eventData: any) => {
            onEvent(_eventData);
        });
    }

    public leavePrivateChannel(): void {
        if (!this.echo) {
            return;
        }
        this.echo.leave(this.privateChannel);
    }
}
